// extracted by mini-css-extract-plugin
module.exports = {"svgColor":"Icons_svgColor__gww_l","hoverable":"Icons_hoverable__3SJis","hovered":"Icons_hovered__19oqF","active":"Icons_active__3MYtc"};